export enum NodeGraphDataFrameFieldNames {
  id = 'id',
  title = 'title',
  subTitle = 'subtitle',
  mainStat = 'mainstat',
  secondaryStat = 'secondarystat',
  source = 'source',
  target = 'target',
  detail = 'detail__',
  arc = 'arc__',
  color = 'color',
}
